import { useEffect } from 'react';
import { EventBasedStore } from '../utils/EventBasedStore';
import { isBrowser } from '../utils/trick';

type SeoSetting = {
  title?: string;
  desc?: string;
};

type SeoState = SeoSetting & {
  keywords?: string;
  mediaShare: {
    twitter?: SeoSetting;
    og?: SeoSetting;
  };
};

type SeoStoreState = {
  currentUrl?: URL;
  seoStack: SeoState[];
};

const compute = ({ seoStack }: SeoStoreState) => {
  const lastSeoSetting = seoStack[seoStack.length - 1];
  return {
    lastSeoSetting: lastSeoSetting as SeoState | undefined,
  };
};

type Compute = ReturnType<typeof compute>;

class SeoStateStore extends EventBasedStore<SeoStoreState, Compute> {
  constructor() {
    super(
      {
        currentUrl: isBrowser ? new URL(window.location.href) : undefined,
        seoStack: [],
      },
      compute,
      () => {
        if (isBrowser) {
          window.addEventListener('popstate', () => {
            this.setState({
              currentUrl: new URL(window.location.href),
            });
          });
        }
      },
    );
  }

  pushSeo(state: SeoState) {
    const { seoStack } = this.state;
    const newStack = [...seoStack, state];
    this.setState('seoStack', newStack);
  }
  removeSeo(state: SeoState) {
    const { seoStack } = this.state;
    this.setState(
      'seoStack',
      seoStack.filter((seo) => seo !== state),
    );
  }
}

export const seoStateStore = new SeoStateStore();

export const useSeo = (state: SeoState) => {
  useEffect(() => {
    seoStateStore.pushSeo(state);
    return () => {
      seoStateStore.removeSeo(state);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(state)]);
};
